import React from 'react';
import Slider from 'react-slick';
import PT from 'prop-types';
import _ from 'lodash';
import sliderBtnImg from 'assets/client/imgs/slider-btn.png';
import { Responsive } from 'common/components';
import Container from '../Container';
import SliderSlide from './SliderSlide';
import * as css from './SliderComponent.scss';

export default class SliderComponent extends React.PureComponent {
	static propTypes = {
		className: PT.string,
		items: PT.oneOfType([PT.shape({}), PT.arrayOf(PT.shape({}))]).isRequired,
		isPodcast: PT.bool,
		currentItemId: PT.string,
	};

	static defaultProps = {
		className: '',
		isPodcast: false,
		currentItemId: '',
	};

	state = {
		currentItemId: this.props.currentItemId || '',
	};

	onNextClick = () => {
		this.slider.slickNext();
	};

	onPrevClick = () => {
		this.slider.slickPrev();
	};

	onSlideClick = id => {
		this.setState({ currentItemId: id });
	};

	renderSlider = () => {
		const { items } = this.props;
		const sortedItems = _.sortBy(items, ['order']);
		const sliderConfig = {
			className: 'center',
			centerMode: true,
			infinite: true,
			centerPadding: '13px',
			lazyLoad: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			speed: 500,
			// rtl: true,
			rows: 1,
		};
		const sliderTitle = 'לספריית הפודקסטים המלאה:';

		return (
			<Container className={css.slider}>
				<h2 className={css.sliderTitle}>{sliderTitle}</h2>
				<div className={css.sliderWrap}>
					{/* eslint-disable-next-line no-return-assign */}
					<Slider ref={slider => (this.slider = slider)} {...sliderConfig}>
						{_.map(sortedItems, item => (
							<SliderSlide key={item.id} {...item} />
						))}
					</Slider>
					<div className={css.sliderControls}>
						<button className={css.sliderControlsPrev} onClick={this.onPrevClick} type="button">
							<img src={sliderBtnImg} alt="" />
						</button>
						<button className={css.sliderControlsNext} onClick={this.onNextClick} type="button">
							<img src={sliderBtnImg} alt="" />
						</button>
					</div>
				</div>
			</Container>
		);
	};

	sliderTemplate = (sortedItems, currentItemId) => {
		const { isPodcast } = this.props;
		setTimeout(() => {
			if (this.slider) {
				this.slider.slickGoTo(5, true);
			}
		}, 1000);
		return _.map(sortedItems, item => (
			<SliderSlide
				className={css.mobileSlide}
				key={item.id}
				{...item}
				isPodcast={isPodcast}
				onSlideClick={this.onSlideClick}
			/>
		));
	};

	renderMobilePart = () => {
		const { items } = this.props;
		const { currentItemId } = this.state;
		const itemsOmit = _.filter(items, item => item.id !== currentItemId);
		const sortedItems = _.sortBy(itemsOmit, ['order']);

		return (
			<div id="mobile-slides">{!_.isEmpty(sortedItems) && this.sliderTemplate(sortedItems, currentItemId)}</div>
		);
	};

	render() {
		return (
			<React.Fragment>
				<Responsive query={Responsive.DESKTOP}>{this.renderSlider()}</Responsive>
				<Responsive query={Responsive.MOBILE}>{this.renderMobilePart()}</Responsive>
			</React.Fragment>
		);
	}
}
